import app from './app';
import { ORDER_SERVICE_URL } from '../../libs/constants';

const getDirectCustomerOrderList = (userId, requestData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        console.log('Search Config of Direct Customer Order list API: ' + JSON.stringify(requestData));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getDirectCustomerOrderList" } };
        const response = await api.post(ORDER_SERVICE_URL + '/list/' + userId, requestData, headerConfig);

        dispatch({ type: "SET_DIRECT_CUSTOMER_ORDER_LIST", data: response.data });
        dispatch(app.setLoading(false));
    } catch (error) {
        console.log(error);
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const getFinanacialDirectCustomerOrderList = (userId, requestData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        console.log('Search Config of Direct Customer Order list API: ' + JSON.stringify(requestData));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getFinanacialDirectCustomerOrderList" } };
        const response = await api.post(ORDER_SERVICE_URL + '/list/' + userId, requestData, headerConfig);

        dispatch({ type: "SET_FINANCIAL_DIRECT_CUSTOMER_ORDER_LIST", data: response.data });
        dispatch(app.setLoading(false));
    } catch (error) {
        console.log(error);
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const getDirectCustomerOrderDetails = (userId, orderId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const headerConfig = { headers: { "DRS-Fetch-Type": "getOrderDetails" } };
    await api.post(ORDER_SERVICE_URL + `/${userId}/` + orderId, {}, headerConfig)
        .then(response => {
            dispatch({ type: "SET_ORDER_DETAILS", data: response.data });
            if (response.data?.vendorNarratives) {
                dispatch({ type: "SET_AF_NARRATIVES", data: response.data.vendorNarratives });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const getAFNarratives = (userId, orderId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getAFNarratives" } };
        const response = await api.get(ORDER_SERVICE_URL + `/vendor/narratives/${userId}`, {}, headerConfig);
        if (response.data.length) {
            dispatch({ type: "SET_AF_NARRATIVES", data: response.data });
        }
        dispatch(app.setLoading(false));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const resetNarratives = () => async (dispatch) => {
    dispatch({
        type: "RESET_AF_NARRATIVES"
    })
}

const saveAFNarratives = (userId, orderId, narratives) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        const headerConfig = { headers: { "DRS-Fetch-Type": "saveAFNarratives" } };
        const response = await api.post(ORDER_SERVICE_URL + `/saveNarratives/${userId}/${orderId}`, narratives, headerConfig);
        dispatch(app.setLoading(false));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const updateNarratives = (key, value) => {
    return {
        type: 'UPDATE_NARRATIVES',
        key,
        value
    }
}

const resolveOrderDispute = (requestBody) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        const headerConfig = { headers: { "DRS-Fetch-Type": "updateDisputeStatus" } };
        await api.post(ORDER_SERVICE_URL + '/updateDisputeStatus', requestBody, headerConfig).then(response => {
            dispatch({ type: "SET_ORDER_DETAILS", data: response.data[0] });
        });
        dispatch(app.setLoading(false));
    } catch (error) {
        dispatch(app.setLoading(false));
    }
};

const cancelOrder = (userId, orderId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "orderCancellation" } };
        await api.post(ORDER_SERVICE_URL + '/cancel/' + `${userId}/` + orderId, {}, headerConfig);

        dispatch(app.setLoading(false));
        dispatch(getDirectCustomerOrderDetails(userId, orderId));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const uploadVendorAFReport = (userId, orderId, fileData, isCtUpload, isRevitalize) => async (dispatch, getState, api) => {
    let urlPath = '/report/upload/'
    if (isCtUpload && isRevitalize) {
        urlPath = '/report/ctupload/'
    }

    try {
        dispatch(app.setLoading(true));

        console.log('File data : ' + JSON.stringify(fileData));
        const headerConfig = { headers: { "DRS-Fetch-Type": "uploadVendorAFReport", 'content-type': 'multipart/form-data', } };
        const response = await api.post(urlPath + userId + '/' + orderId, fileData, headerConfig);
        console.log('Response of Direct Customer file upload : ' + JSON.stringify(response));

        dispatch(app.setLoading(false));
    } catch (error) {
        console.log(error);
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const updateOrdersInformation = (updatedOrdersData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getUpdatedOrdersData" } };
        await api.post(ORDER_SERVICE_URL + '/updateOrderStatus', updatedOrdersData, headerConfig);

        dispatch(app.setLoading(false));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const updateSpecificOrderData = (value, columnName, rowIndex) => {
    return {
        type: 'UPDATE_SPECIFIC_ORDER_DATA',
        value,
        columnName,
        rowIndex
    }
};

const updateFinancialDetail = (value, columnName, rowIndex) => {
    return {
        type: 'UPDATE_FINANCIAL_DETAILS',
        value,
        columnName,
        rowIndex
    }
};

const directCustomerActions = {
    getDirectCustomerOrderList,
    getFinanacialDirectCustomerOrderList,
    uploadVendorAFReport,
    getDirectCustomerOrderDetails,
    getAFNarratives,
    saveAFNarratives,
    resetNarratives,
    updateNarratives,
    cancelOrder,
    updateFinancialDetail,
    resolveOrderDispute,
    updateSpecificOrderData,
    updateOrdersInformation
}

export default directCustomerActions;